import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "./StudentFeedbackForm.css";
import Button from "../../common/Button/Button";
import DatePickerInput from "../../common/FormFields/DatePickerInput.jsx";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "react-bootstrap";
import TextInput from "../../common/FormFields/TextInput.jsx";
import SelectInput from "../../common/FormFields/SelectInput.jsx";
import FileInput from "../../common/FormFields/FileInput.jsx";

const StudentFeedbackForm = () => {
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    contactNumber: Yup.string().required("Contact number is required"),
    course: Yup.string().required("Course is required"),
    passportPhoto: Yup.mixed().required("Passport photo is required"),
    aadharFront: Yup.mixed().required("Aadhar front photo is required"),
    aadharBack: Yup.mixed().required("Aadhar back photo is required"),
    dateOfBirth: Yup.date().nullable().required("Date of Birth is required"),
    fees: Yup.string().required("Fees is required"),
    paidAmount: Yup.string().required("Paid Amount is required"),
    remainingAmount: Yup.string().required("Remaining Amount is required"),
    parentName: Yup.string().required("Parent Name is required  "),
    whoYouAre: Yup.string().required("Who you are is required"),
    mode: Yup.string().required("Mode of class is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    personalDocumentNumber: Yup.string().required(
      "Personal Document Number is required"
    ),
    prefferedBatch: Yup.string().required("Preffered Batch is required"),
    currentAddress: Yup.string().required("Current Address is required"),
    permanentAddress: Yup.string().required("Permanent Address is required"),
    organisationName: Yup.string().required("Organisation Name is required"),
    aadharCardNumber: Yup.string().required("Aadhar Card Number is required"),
    gender: Yup.string().required("Gender is required"),
    paymentMode: Yup.string().required("Payment Mode is required"),
    parentMobile: Yup.string().required("Parent Mobile is required"),
  });

  const [passportPhoto, setPassportPhoto] = useState(null);
  const [aadharFront, setAadharFront] = useState(null);
  const [aadharBack, setAadharBack] = useState(null);
  // const containerStyle = {
  //   width: window.innerWidth <= 375 ? "90%" : "auto",
  // };
  return (
    <>
      <Card className='pt-4'>
        <Formik
          initialValues={{
            name: "",
            email: "",
            contactNumber: "",
            course: "",
            fees: "",
            paidAmount: "",
            remainingAmount: "",
            parentName: "",
            gender: "",
            paymentMode: "",
            whoYouAre: "",
            mode: "",
            city: "",
            state: "",
            country: "",
            personalDocumentNumber: "",
            prefferedBatch: "",
            passportPhoto: null,
            aadharFront: null,
            aadharBack: null,
            dateOfBirth: null,
            currentAddress: "",
            permanentAddress: "",
            organisationName: "",
            aadharCardNumber: "",
            parentMobile: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            try { 
              resetForm();
              setPassportPhoto(null);
              setAadharFront(null);
              setAadharBack(null);
            } catch (error) {
         
              resetForm();
              setPassportPhoto(null);
              setAadharFront(null);
              setAadharBack(null);
             
            }
          }}
        >
          {({ resetForm }) => (
            <CardBody>
              <Form>
                <Row>
                  <Col sm={1} lg={4} md={4}>
                    <TextInput label="Name" name="name" />
                  </Col>
                  <Col sm={1} lg={4} md={4}>
                    <TextInput label="Email" name="email" type="email" />
                  </Col>
                  <Col sm={1} lg={4} md={4}>
                    <TextInput
                      label="Contact Number"
                      name="contactNumber"
                      type="tel"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm={1} lg={4} md={4}>
                    <TextInput
                      label="Which course have you taken addmission for?"
                      name="course"
                    />
                  </Col>
                  <Col sm={1} lg={4} md={4}>
                    <SelectInput
                      label="Mode of Class"
                      name="mode"
                      options={[
                        { label: "Select mode of class", value: "" },
                        { label: "OnlineTraining", value: "OnlineTraining" },
                        {
                          label: "ClassroomTraining",
                          value: "ClassroomTraining",
                        },
                      ]}
                    />
                  </Col>

                  <Col sm={1} lg={4} md={4}>
                    <SelectInput
                      label="Preffered Batch"
                      name="prefferedBatch"
                      options={[
                        { label: "Select", value: "" },
                        { label: "Weekdays", value: "Weekdays" },
                        { label: "Weekend", value: "Weekend" },
                        { label: "Other", value: "Other" },
                      ]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm={1} lg={4} md={4}>
                    <TextInput label="Total Fees" name="fees" />
                  </Col>

                  <Col sm={1} lg={4} md={4}>
                    <TextInput label="Paid Amount" name="paidAmount" />
                  </Col>

                  <Col sm={1} lg={4} md={4}>
                    <TextInput
                      label="Remaining Amount"
                      name="remainingAmount"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={1} lg={4} md={4}>
                    <DatePickerInput
                      label="Due Date"
                      name="dueDate"
                      dateFormat="dd/MM/yyyy"
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={100}
                      maxDate={new Date()}
                      // className="dateInput"
                    />
                  </Col>
                  <Col sm={1} lg={4} md={4}>
                    <SelectInput
                      label="Gender"
                      name="gender"
                      options={[
                        { label: "Select", value: "" },
                        { label: "Male", value: "male" },
                        { label: "Female", value: "female" },
                        { label: "Other", value: "other" },
                      ]}
                    />
                  </Col>

                  <Col sm={1} lg={4} md={4}>
                    <SelectInput
                      label="Payment Mode"
                      name="paymentMode"
                      options={[
                        { label: "Select", value: "" },
                        { label: "Online Payment", value: "online" },
                        { label: "Cash Payment", value: "cash" },
                      ]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm={1} lg={6} md={6}>
                    <TextInput label="Parent/Spouse Name" name="parentName" />
                  </Col>
                  <Col sm={1} lg={6} md={6}>
                    <TextInput
                      label="Parent/Spouse Mobile Number"
                      name="parentMobile"
                    />
                  </Col>
                </Row>

                <Row
                  style={{
                    justifyContent: "center",
                    alignItems: "baseline",
                  }}
                >
                  <div className="col-lg-6 ">
                    <TextInput
                      label="Aadhar Card Number"
                      name="aadharCardNumber"
                    />
                  </div>
                  <div className="col-lg-6">
                    <DatePickerInput
                      label="Date of Birth"
                      name="dateOfBirth"
                      dateFormat="dd/MM/yyyy"
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={100}
                      maxDate={new Date()}
                    />
                  </div>
                </Row>

                <Row>
                  <Col sm={1} lg={4} md={4}>
                    <FileInput
                      label="Upload Passport Size Photo"
                      name="passportPhoto"
                      setPhoto={setPassportPhoto}
                      photoPreview={passportPhoto}
                    />
                  </Col>

                  <Col sm={1} lg={4} md={4}>
                    <FileInput
                      label="Upload Aadhar Front Photo"
                      name="aadharFront"
                      setPhoto={setAadharFront}
                      photoPreview={aadharFront}
                    />
                  </Col>
                  <Col sm={1} lg={4} md={4}>
                    <FileInput
                      label="Upload Aadhar Back Photo"
                      name="aadharBack"
                      setPhoto={setAadharBack}
                      photoPreview={aadharBack}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={1} lg={4} md={4}>
                    <TextInput label="City Name" name="city" />
                  </Col>
                  <Col sm={1} lg={4} md={4}>
                    <TextInput label="State Name" name="state" />
                  </Col>

                  <Col sm={1} lg={4} md={4}>
                    <TextInput label="Country Name" name="country" />
                  </Col>
                </Row>

                <Row>
                  <Col sm={1} lg={6} md={4}>
                    <TextInput
                      label="Personal Document(Aadhar Card, Passport, Driving License Number)"
                      name="personalDocumentNumber"
                    />
                  </Col>

                  <Col sm={1} lg={6} md={4}>
                    <SelectInput
                      label="Who you are?"
                      name="whoYouAre"
                      options={[
                        { label: "Select", value: "" },
                        { label: "Student", value: "student" },
                        {
                          label: "Professional/Employed",
                          value: "professional",
                        },
                        { label: "Self-employed", value: "selfEmployed" },
                      ]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm={1} lg={6} md={4}>
                    <TextInput label="Current Address" name="currentAddress" />
                  </Col>

                  <Col sm={1} lg={6} md={4}>
                    <TextInput
                      label="Permanent Address"
                      name="permanentAddress"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm={1} lg={12} md={12}>
                    <TextInput
                      label="Organisation Name"
                      name="organisationName"
                    />
                  </Col>
                </Row>

                <Row className="mb-3 mt-3">
                  <label className="">
                    <Link to="terms-and-conditions">
                      Terms &amp; Conditions
                    </Link>{" "}
                    {/* <span className="text-danger">*</span> */}
                  </label>
                  <div className="col-lg-4 mt-1">
                    <label
                      className="form-check css-control-primary css-checkbox"
                      htmlFor="val-terms"
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input me-2 mt-0"
                        id="val-terms"
                        name="val-terms"
                        value="1"
                      />
                      <span className="css-control-indicator"></span> Agree to
                      terms and conditions
                    </label>
                  </div>
                </Row>

                <div
                  className=""
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    label="Submit"
                    type="submit"
                    variant="primary"
                    className="submitButton customButton w-50"
                  />
                </div>
              </Form>
            </CardBody>
          )}
        </Formik>
      </Card>
    </>
  );
};

export default StudentFeedbackForm;
